/* global espn espn_ui jQuery */
import { memoizr, mapPageToTemplate } from '../../reduxion-core/lib'
import actionTypes from '../constants/actionTypes'
import analytics from '../lib/utils/analytics'
import { renderOutbrain } from '../components/common/Outbrain'
import { getHost, getQueryString } from './api'
import moment from 'moment-timezone'
import selectn from 'selectn'

/**
 * get page config on client
 * Config for: ads, analytics etc.
 * @param  {Object} edition     edition config
 * @param  {Object} params      Router params
 * @return {Object}             action
 */
export function getPageConfig({ edition = {}, params = {} }) {
  const queryObject = {
    pageShell: true,
    xhr: 1
  }
  const host = edition.host
  const editionKey = edition.editionKey
  const localEditionKey = edition.localEditionKey
  const lang = edition.language
  const region = edition.country
  const sport = params.sport
  const pageType = params.pageType
  const template = mapPageToTemplate({ pageType, sport })
  const sCoreTcClient = getHost('score')

  if (template === 'standings' || template === 'scoreboard') {
    if (params.league) {
      queryObject.league = params.league
    }
    if(params.team) {
      queryObject.team = params.team
    }
    if (params.season) {
      queryObject.season = params.season
    }
  }

  if (editionKey && localEditionKey) {
    queryObject['edition'] = editionKey
    queryObject['edition-view'] = localEditionKey
  } else {
    queryObject['edition-host'] = host
    queryObject.lang = lang
    queryObject.region = region
  }

  const queryString = getQueryString(queryObject, params, edition)
  
  let url = `${sCoreTcClient}/${params.sport}/${template === 'gamepackage' ? 'game' : template}${queryString}`

  if(template === 'clubhouse') {
    url =  `${sCoreTcClient}/${params.sport}/team/_/id/${params.team}${queryString}`
  }
  return {
    sport: sport,
    pageType: pageType,
    type: actionTypes.PAGE_CONFIG,
    promise: memoizr.get(url)
  }
}

/**
 * Validate and get page config if required
 * @param  {Object} edition     edition config
 * @param  {Object} params      Router params
 * @return {undefined}
 */
export function validatePageConfig({ edition = {}, params = {} }) {
  return (dispatch, getState) => {
    const state = getState()
    const page = state.page || {}
    const { sport, pageType } = page
    
    // Make page config if not a webview and page/sport has changed
    if(!params.platform && (sport !== params.sport || pageType !== params.pageType)) {
      dispatch(getPageConfig({ edition, params }))
    }
  }
}

/**
 * Set page config - ads, analytics
 * that come along with the page shell
 * @param  {Object} edition     edition config
 * @param  {Object} params      Router params
 * @param  {Object} location    location params
 * @param  {Object} config      config
 * @return {Object}             page config action type
 */
export function setPageConfig({ ...config }) {
  return {
    ...config,
    type: actionTypes.PAGE_CONFIG
  }
}

/**
 * onRenderComplete callback
 * @param  {Boolean} initialLoad initial page load
 * @param  {Boolean} historyChange history change
 * @param  {Boolean} pathnameChange pathname change
 * @return {undefined}
 */
export function onRenderComplete({ initialLoad, historyChange, pathnameChange }) {
  return (dispatch, getState) => {
    const state = getState()
    const edition = selectn('page.edition', state)
    const pageType = selectn('page.params.pageType', state)
    
    if(!historyChange) {
      analytics.init(state, initialLoad, pathnameChange)
      if(pageType == 'report' || pageType === 'preview') {
        const obConfig = edition.outbrain.report || edition.outbrain  
        renderOutbrain({ id: obConfig.desktop.compliantId })
      }
    }
    try{
      const tier3Nav = selectn('page.tier3Nav', state) || initialLoad && selectn('nav.tier3',espn)
      const tier2Nav = selectn('page.tier2Nav', state) || initialLoad && selectn('nav.tier2',espn)
      if(typeof espn_ui.Helpers.nav == 'undefined') {
        espn_ui.Helpers.nav = {}
      }
      if(tier3Nav) {
        espn_ui.Helpers.nav.tier3Nav = tier3Nav
      }else {
        espn_ui.Helpers.nav.tier3Nav = null
      }

      if(tier2Nav) {
        espn_ui.Helpers.nav.tier2Nav = tier2Nav
      }else {
        espn_ui.Helpers.nav.tier2Nav = null
      }

      const t2LoadType = jQuery('#global-nav-secondary').attr('data-loadtype')
      if(!initialLoad || initialLoad && t2LoadType !== 'server') {
        jQuery(document).trigger('nav.sportChange')
      }
    }catch(e) { console.log(e) }

    console.info('onRenderComplete')
  }
}

/**
 * updateTimeZone
 * @param  {Object} edition     edition config
 * @param  {Object} params      Router params
 * @return {Object} action object
 */
export function updateTimeZone(edition={}, params={}, query={}) {
  const timeZone = moment.tz.guess() || ''
  const timeZoneAbbr = timeZone ? moment.tz(timeZone).format('z') : ''
  return {
    zone: timeZone,
    zoneAbbr: timeZoneAbbr,
    type: actionTypes.UPDATE_TIMEZONE,
    edition,
    params,
    query
  }
}

/**
 * update the appProps
 * @param {Object} options.appProps app props
 * @return {Object} action object
 */
export function setAppProps({ appProps }) {
  return {
    appProps,
    type: actionTypes.APP_PROPS 
  }
}
/**
 * update gamestrip 
 * @param {String} sport sport cricket
 * @return {Object} action object
 */
export function updateGameStrip(sport = '') {
  return {
    sport,
    type: actionTypes.UPDATE_GAMESTRIP_TIME
  }
}



// WEBPACK FOOTER //
// ../app/actions/index.js